import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Api } from "../../services/interceptor";
import { QUERY_KEY } from "../../services/queryEndPoint";
import LiveMatchPage from "./live/LiveMatchPage";
import UpcomingMatchPage from "./upcoming/UpcomingMatchPage";
import ResultMatchPage from "./result/ResultMatchPage";
import MatchesDetails from "../leaguesHome/tournaments/tournamentsDetails/matches/matchesDetails/MatchesDetails";

/** /matches-details/:matchId -> live, upcoming or result page by match status (old page as fallback). */
const MatchPageRouter = () => {
  const { matchId = "" } = useParams();
  const { data, isLoading } = useQuery<{ matchStatus?: string }>({
    queryKey: [QUERY_KEY.getMatchInfo, matchId],
    queryFn: async () => (await Api.get(`${QUERY_KEY.getMatchInfo}/${matchId}`)).data,
    enabled: !!matchId,
  });
  if (isLoading) return <div style={{ padding: "140px 24px", textAlign: "center", color: "#687080" }}>Loading match…</div>;
  const s = (data?.matchStatus ?? "").toUpperCase().replace(/\s+/g, "_");
  if (s === "IN_PROGRESS") return <LiveMatchPage matchId={matchId} />;
  if (s === "SCHEDULED" || s === "UPCOMING") return <UpcomingMatchPage matchId={matchId} />;
  if (s === "ENDED" || s === "COMPLETED" || s === "FINISHED" || s === "ABANDONED") return <ResultMatchPage matchId={matchId} />;
  return <MatchesDetails />;
};
export default MatchPageRouter;
